import React from 'react';
import { Table, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';

import { LogSyncStep } from '@totem/components/administration/logSync/details/types';

const columns: ColumnsType<LogSyncStep> = [
  {
    title: 'Success',
    dataIndex: 'success',
    key: 'success',
    width: 100,
    render: (success: boolean) => (
      <Tag color={success ? 'success' : 'error'}>{success ? 'Yes' : 'No'}</Tag>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'statusCode',
    key: 'statusCode',
    width: 90,
  },
  {
    title: 'Namespace',
    dataIndex: 'namespace',
    key: 'namespace',
  },
  {
    title: 'Step',
    dataIndex: 'stepName',
    key: 'stepName',
  },
  {
    title: 'Outcome',
    dataIndex: 'outcome',
    key: 'outcome',
  },
  {
    title: 'Error',
    dataIndex: 'error',
    key: 'error',
    render: (error: string) => error || '—',
  },
];

type Props = {
  steps: LogSyncStep[];
};

const LogSyncStepsTable = ({ steps }: Props) => (
  <Table<LogSyncStep>
    columns={columns}
    dataSource={steps}
    rowKey={(_, index) => String(index)}
    size="small"
    pagination={{ defaultPageSize: 10, showSizeChanger: true }}
  />
);

export default LogSyncStepsTable;
